/**
 * Predictive search — Shopify suggest.json
 */
(function () {
  'use strict';

  function debounce(fn, ms) {
    var t;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms);
    };
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function init() {
    var input = document.querySelector('[data-nw-predictive-search-input]');
    var out = document.querySelector('[data-nw-predictive-search-results]');
    if (!input || !out) return;

    var run = debounce(function () {
      var q = (input.value || '').trim();
      if (q.length < 2) {
        out.innerHTML = '';
        out.setAttribute('hidden', 'hidden');
        return;
      }
      var url =
        '/search/suggest.json?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=8';

      fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          var res = data.resources && data.resources.results;
          if (!res) {
            out.innerHTML = '';
            out.setAttribute('hidden', 'hidden');
            return;
          }
          var html = '<div class="nw-predictive__group">';
          (res.queries || []).slice(0, 6).forEach(function (item) {
            html +=
              '<a class="nw-predictive__link" href="' +
              esc(item.url || '#') +
              '" data-nw-search-submit>' +
              esc(item.text || '') +
              '</a>';
          });
          html += '</div><div class="nw-predictive__group">';
          (res.products || []).slice(0, 6).forEach(function (p) {
            html +=
              '<a class="nw-predictive__link" href="' +
              esc(p.url || '#') +
              '" data-nw-product-card><span class="nw-visually-hidden">Product </span>' +
              esc(p.title || '') +
              '</a>';
          });
          html += '</div>';
          (res.collections || []).slice(0, 4).forEach(function (c) {
            html +=
              '<a class="nw-predictive__link" href="' +
              esc(c.url || '#') +
              '">' +
              esc(c.title || '') +
              '</a>';
          });
          out.innerHTML = html || '<p class="nw-predictive__empty">—</p>';
          out.removeAttribute('hidden');
        })
        .catch(function () {
          out.innerHTML = '';
          out.setAttribute('hidden', 'hidden');
        });
    }, 200);

    input.addEventListener('input', run);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
